import { render, staticRenderFns } from "./PFile.vue?vue&type=template&id=94972baa&scoped=true"
import script from "./PFile.vue?vue&type=script&lang=js"
export * from "./PFile.vue?vue&type=script&lang=js"
import style0 from "./PFile.vue?vue&type=style&index=0&id=94972baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94972baa",
  null
  
)

export default component.exports